import React from "react";

interface PaymentOptionProps {
  icon: string;
  label: string;
  id: string;
  onClick: () => void;
}

const PaymentOption: React.FC<PaymentOptionProps> = ({ icon, label, id, onClick }) => {
  return (
    <div className="flex flex-col items-center justify-center cursor-pointer" onClick={onClick}>
      <img src={icon} id={id} alt={label} className="w-screen h-[20vh] mb-5 object-contain" />
      <p className="text-center text-base font-medium">{label}</p>
    </div>
  );
};

export default PaymentOption;
